import HtmlBlock from '~/components/Helpers/HtmlBlock'
import TabComp from './Tabs'
import Icons from '../Icons/Icons'

interface TabWrapProps {
  content: {
    icons?: boolean
    contentTabbedContent: {
      id?: number
      heading?: string
      copy?: string
      icon?: { asset: { sys: { uri: string } } }
      backgroundColour?:
        | 'ink-blue'
        | 'mid-blue'
        | 'light-blue'
        | 'light-pink'
        | 'light-purple'
        | 'light-orange'
        | 'light-aqua'
        | undefined
    }[]
  }
  layoutColour?: AllBackgroundColours
}

const TabWrap = ({ content, layoutColour }: TabWrapProps) => {
  const filteredContent = content?.contentTabbedContent?.map((item, index) => ({
    id: index,
    header: item.heading ?? '',
    content: <HtmlBlock content={item.copy} />
  }))

  const filteredIcons = content?.contentTabbedContent
    ?.filter(item => !!item.icon)
    .map((item, index) => ({
      id: index,
      header: item.heading ?? '',
      content: item.copy ?? '',
      icon: item.icon as { asset: { sys: { uri: string } } },
      bgColour: item?.backgroundColour
    }))

  return content?.icons ? (
    <Icons variant='horizontal' tabs={filteredIcons} />
  ) : (
    <TabComp tabs={filteredContent} layoutColour={layoutColour} />
  )
}

export default TabWrap
